import { z } from 'zod'

export const DATABASES = ['new', 'old', 'both'] as const
export type Database = (typeof DATABASES)[number]

export const baseInstrumentSchema = z.object({
  database: z.enum(DATABASES),
  unit_multiplier: z.number(),
  quote_factor: z.number(),
})

export type BaseInstrumentSchemaType = z.infer<typeof baseInstrumentSchema>
